//状态码！
const errcodes = {
  SUCCESS: 200,         //success
  REDIRECT: 304,        //redirect
  UN_LOGIN: 10001,      //没有登录
  BIND_PHONE: 10002,     //没有绑定手机,
  MESSAGE: 10003,          //提醒操作
  SHARE_PHONE:13333,      //分享没有绑定手机
  API_PUBLIC:101010101    //取消首页判断登陆
};

export default errcodes;